import { LoanStatements } from '../models/loan.model';
import { LoanStatement } from '../models/loan.model';
import { LoanStatementDto } from '../models/dtos/loan-statement.dto';

export class LoanStatementsMapper {
  static toDto(model: LoanStatements): LoanStatementDto[] {
    return model.primaryStatement
      ? [this.statementToDto(model.primaryStatement), ...model.statements.map(this.statementToDto)]
      : []; // No primary statement means no statements
  }

  static toModel(dtos: LoanStatementDto[]): LoanStatements {
    // If the array is empty, return empty LoanStatements
    if (!dtos || dtos.length === 0) {
      return {
        primaryStatement: null,
        statements: [],
        hasStatements: false,
      };
    }

    const statements = dtos.map(this.dtoToStatement);
    const [primaryStatement, ...restStatements] = statements;
    return {
      primaryStatement,
      statements: restStatements,
      hasStatements: true,
    };
  }

  private static statementToDto(statement: LoanStatement): LoanStatementDto {
    return {
      statement_date: statement.statementDate.toISOString(),
      due_date: statement.statementDueDate ? statement.statementDueDate.toISOString() : null,
      past_due_balance: statement.pastDueBalance.toString(),
      current_balance: statement.currentBalance.toString(),
      current_payoff: statement.currentPayoff.toString(),
      row_id: statement.documentId,
    };
  }

  private static dtoToStatement(dto: LoanStatementDto): LoanStatement {
    return {
      statementDate: new Date(dto.statement_date),
      statementDueDate: dto.due_date ? new Date(dto.due_date) : null,
      pastDueBalance: +(dto.past_due_balance || 0),
      currentBalance: +(dto.current_balance || 0),
      currentPayoff: +(dto.current_payoff || 0),
      documentId: +dto.row_id,
    };
  }
}
